import { Template } from "../template"
import { getRandom, map } from "../utils/math"

const CANDY3D = require("../../vendors/candy3d.min.js")

class Wave extends Template {
  constructor() {
    super({ name: "Dark Wave", ratio: 1 })
  }

  setup() {
    // 17 april 2021
    this.speed = 0
    this.accel = 0.005
    this.distance = 4
    this.follow = false

    this.scene = new CANDY3D.Scene()
    this.camera = new CANDY3D.Camera(0.9)
    this.renderer = new CANDY3D.CanvasRenderer()
    document.body.appendChild(this.renderer.domElement)

    this.plane = new CANDY3D.Plane()
    this.plane.position.z = 76
    this.plane.rotation.x = 1.102705
    this.scene.add(this.plane)

    this.light = new CANDY3D.Light(0xffffff, 0xffffff)
    this.light.position.z = 0.9
    this.scene.addLight(this.light)
  }

  resize(width, height) {
    this.renderer.resize(width, height)
  }

  up() {
    this.follow = !this.follow
  }

  update() {
    let x = this.distance * Math.cos(2 * Math.PI * this.speed)
    let y = this.distance * Math.sin(2 * Math.PI * this.speed)

    if (this.follow) {
      x = map(this.mouse.nx, 0, 1, -this.distance, this.distance)
      y = map(this.mouse.ny, 0, 1, -this.distance * 2, this.distance * 2)
    }

    this.light.position.x = x
    this.light.position.y = y

    for (var i = 0; i < this.plane.geometry.vertices.length; i++) {
      this.plane.geometry.vertices[i].z =
        1 * Math.cos(2 * Math.PI * this.speed + i)
    }
    this.speed += this.accel
    this.renderer.render(this.scene, this.camera)
  }
}

const app = new Wave()
